import axios from 'axios';

export const endpoints = {
  api: process.env.REACT_APP_API_URL,
  adminBase: 'admin/',
  plans: 'plans/'
};

export interface Feature {
  featureId: number;
  enabled: boolean;
  volumeLimits?: {
    products?: number;
  };
}
export interface Plan {
  id: number;
  name: string;
  defaultSpecs: {
    features: Feature[];
  };
  stripeProductId: string | null;
  language: 'en' | 'es';
  deprecated: boolean;
  price: string;
  accountPlanCount: number;
  createdAt: string;
  updatedAt: string;
}

export interface PlanResponse {
  totalItems: number;
  plans: Plan[];
  totalPages: number;
  currentPage: number;
}

const getAll = () => {
  return axios.get<PlanResponse>(`${endpoints.api}${endpoints.adminBase}${endpoints.plans}/`, {
    withCredentials: true
  });
};

const PlansService = {
  getAll
};

export default PlansService;
